import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

const CustomInput = () => {
  return (
    <SvgIcon style={{ width: '24px', height: '24px' }} viewBox="0 0 24 24">
      <g>
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          transform="translate(24) rotate(90)"
          d="M2 4 v2 h20 V4 H20z m6 10 h8 v10 h-8 v-10 h-4 l8 -7 l8 7z"
        />
      </g>
    </SvgIcon>
  );
};

export default CustomInput;
